import * as React from "react";
import { Typography, Grid } from "@mui/material";
import { useTranslation } from 'react-i18next';
import "./lotterySystem.css";

const AboutUs: React.FC = () => {
  const { t } = useTranslation('translation');

  return (
    <>
      <Typography className="landing-section-heading landing-text-white landing-headers-orange-color" variant="h6" align="center">{t("aboutUs")}</Typography>
      <Grid container className='landing-about-us-description'>{t('aboutUsDescriptionTop')}</Grid>
      <Grid container className='landing-about-us-description'>{t('aboutUsDescriptionBottom')}</Grid>
      <Grid id="contact-us"></Grid>
    </>
  )
}

export default AboutUs;